// import {Configurator, DashboardNavbar, Footer, Sidenav,} from "@/widgets/layout";
import {StatisticsCard} from './widgets/statistics-card'
import {
  BsPerson,
  BsPersonCheckFill,
  BsPersonDashFill,
  BsPersonFill,
  BsPersonFillExclamation,
  BsPersonLinesFill,
  BsPersonVcardFill
} from "react-icons/bs";
import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React from "react";
import StatisticsChart from "./widgets/statistics-chart";
import StackedChart from "./charts/stacked_chart";
import BarChart from "./charts/bar_chart";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function AdminUserAgentsDashboard({userAgents}) {

  const compare_text = (new_count, pre_count, title) => {
    const count_difference = new_count - pre_count;
    if (count_difference === 0) {
      return 'مشابه ماه گذشته'
    } else if (count_difference > 0) {
      return persianNumberFormat(`${count_difference} ${title} بیشتر از ماه گذشته`)
    } else if (count_difference < 0) {
      return persianNumberFormat(`${Math.abs(count_difference)} ${title} کمتر از ماه گذشته`)
    }
  }

  const updated_time = persianNumberFormat(`${userAgents.updated_at.split(" ")[1]} ${userAgents.updated_at.split(" ")[0]}`)

  return (
    <div className="w-full">
      <Card className="pt-8 w-full bg-gray-200">
        <CardHeader floated={true} shadow={false} className="bg-gray-200">
          <div className="mb-8 flex flex-col items-start justify-between md:flex-row">
            <Typography variant="h5" color="blue-gray">کاربران و مباشران</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          <div
            className="grid grid-cols-1 gap-8 mb-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xxl:grid-cols-6">
            <StatisticsCard color="gray" title="کاربران" value={userAgents.users_count}
                            footer={compare_text(userAgents.users_count, userAgents.pre_users_count, 'کاربر')}
                            icon={<BsPersonFill className="text-center" size={40}/>}/>
            <StatisticsCard color="gray" title="مباشران" value={userAgents.agents_count}
                            footer={compare_text(userAgents.agents_count, userAgents.pre_agents_count, 'مباشر')}
                            icon={<BsPersonVcardFill size={40}/>}/>
            <StatisticsCard color="gray" title="مباشران تایید شده" value={userAgents.accepted_agents_count}
                            footer={compare_text(userAgents.accepted_agents_count, userAgents.pre_accepted_agents_count, 'مباشر')}
                            icon={<BsPersonCheckFill size={40}/>}/>
            <StatisticsCard color="gray" title="مباشران در انتظار تایید"
                            value={userAgents.pending_agents_count}
                            footer={compare_text(userAgents.pending_agents_count, userAgents.pre_pending_agents_count, 'مباشر')}
                            icon={<BsPersonFillExclamation size={40}/>}/>
            <StatisticsCard color="gray" title="مباشران رد شده"
                            value={userAgents.rejected_agents_count}
                            footer={compare_text(userAgents.rejected_agents_count, userAgents.pre_rejected_agents_count, 'مباشر')}
                            icon={<BsPersonDashFill size={40}/>}/>
            <StatisticsCard color="gray" title="مباشران مشاوره" value={userAgents.consultation_agents_count}
                            footer={compare_text(userAgents.consultation_agents_count, userAgents.pre_consultation_agents_count, 'مباشر')}
                            icon={<BsPersonLinesFill size={40}/>}/>
            <StatisticsCard color="gray" title="مباشران خدمات" value={userAgents.service_agents_count}
                            footer={compare_text(userAgents.service_agents_count, userAgents.pre_service_agents_count, 'مباشر')}
                            icon={<BsPerson size={40}/>}/>
          </div>
          <div className="grid grid-cols-1 gap-1 mb-8 xl:grid-cols-1">

            {userAgents.admin_agent_field_branch &&
              <StatisticsChart
                color="#fff"
                chart={StackedChart(
                  userAgents,
                  "admin_agent_field_branch",
                  "field_title",
                  "branch_title",
                  "agents_count"
                )}
                title="مباشران به تفکیک رشته"
                description="مباشران به تفکیک هر سرویس"
                footer="آپدیت شده"
              />
            }

            {
              userAgents.agents_province.count &&
              <StatisticsChart
                color="#fff"
                chart={BarChart("مباشران", userAgents.agents_province.count, userAgents.agents_province.title)}
                title="مباشران به تفکیک استان"
                description="مباشران به تفکیک هر استان"
                footer="آپدیت شده"
              />
            }

          </div>

        </CardBody>
      </Card>
    </div>
  );

}

export default AdminUserAgentsDashboard;
